"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createOption = exports.clearState = void 0;
exports.loadOptions = loadOptions;
exports.loadOptionsForProductId = loadOptionsForProductId;
exports.loadOptionsSuccess = void 0;
exports.normalizeOptionData = normalizeOptionData;
exports.updatePrice = updatePrice;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _toPairs = _interopRequireDefault(require("lodash/toPairs"));
var _compact = _interopRequireDefault(require("lodash/compact"));
var _filter = _interopRequireDefault(require("lodash/filter"));
var _find = _interopRequireDefault(require("lodash/find"));
var _flatten = _interopRequireDefault(require("lodash/flatten"));
var _get = _interopRequireDefault(require("lodash/get"));
var _isUndefined = _interopRequireDefault(require("lodash/isUndefined"));
var _map = _interopRequireDefault(require("lodash/map"));
var _omit = _interopRequireDefault(require("lodash/omit"));
var _omitBy = _interopRequireDefault(require("lodash/omitBy"));
var _startsWith = _interopRequireDefault(require("lodash/startsWith"));
var _normalizr = require("normalizr");
var _optionsApi = _interopRequireDefault(require("../api/optionsApi"));
var _optionsApiWithPreSelection = _interopRequireDefault(require("../api/optionsApiWithPreSelection"));
var _pricing = _interopRequireDefault(require("../api/pricing"));
var _settings = require("../settings");
var _filterSelections = _interopRequireDefault(require("../utils/filterSelections"));
var _ajaxStatusActions = require("./ajaxStatusActions");
var _choiceActions = require("./choiceActions");
var _dictionaryActions = require("./dictionaryActions");
var _getVisualizerImageUrl = _interopRequireDefault(require("./getVisualizerImageUrl"));
var _pricingActions = require("./pricingActions");
var _rulesActions = require("./rulesActions");
var _actionTypes = require("./actionTypes");
var _GetOptionsError = _interopRequireDefault(require("../customErrors/GetOptionsError"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function FetchError(message, validationErrors) {
  this.name = 'FetchError';
  this.message = message;
  this.validationErrors = validationErrors || [];
}
var createOption = exports.createOption = function createOption(option) {
  return {
    type: _actionTypes.CREATE_OPTION,
    option: option
  };
};
var clearState = exports.clearState = function clearState() {
  return {
    type: _actionTypes.CLEAR_STATE
  };
};
var loadOptionsSuccess = exports.loadOptionsSuccess = function loadOptionsSuccess(normalizedData, preselectedChoices, productInfo) {
  var alsoClearState = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  return _objectSpread(_objectSpread({
    type: _actionTypes.LOAD_OPTIONS_SUCCESS
  }, normalizedData), {}, {
    preselectedChoices: preselectedChoices,
    productInfo: productInfo,
    clearState: alsoClearState
  });
};
function getSelections(choices, options) {
  return (0, _filter["default"])(choices, function (choice) {
    return (0, _filterSelections["default"])(choice, options, choices);
  }).map(function (choice) {
    var option = options[choice.optionId];
    return {
      ChoiceId: choice.id,
      OptionId: choice.optionId,
      ChoiceValue: choice.value,
      OptionType: option.isDependent ? '' : option.optionType,
      ChoiceType: choice.dataType,
      tags: option.tags
    };
  });
}
function updatePrice(settings, productId) {
  return function (dispatch, getState) {
    var _getState = getState(),
      _getState$configurato = _getState.configurator,
      options = _getState$configurato.options,
      choices = _getState$configurato.choices,
      zipcode = _getState.zipcode;
    var selections = getSelections(choices, options);
    var payload = {
      SiteId: settings.siteId,
      ProductId: productId,
      Choices: selections
    };
    if (zipcode && zipcode.zipcode) {
      payload.Zipcode = zipcode.zipcode;
    }
    dispatch((0, _ajaxStatusActions.beginAjaxCall)());
    dispatch((0, _pricingActions.beginPriceChange)());
    return (0, _pricing["default"])(settings.priceApi, _objectSpread(_objectSpread({}, payload), {}, {
      dispatch: dispatch,
      getState: getState
    })).then(function (response) {
      if (response.status !== 200) {
        throw new Error("An error occurred while fetching: ".concat(response.statusText));
      }
      return response;
    }).then(function (response) {
      return response.data;
    }).then(function (result) {
      if (result.hasValidationErrors && result.validationMessages) {
        throw new FetchError('Error: please fix your selections and try again.', result.validationMessages);
      }
      dispatch((0, _pricingActions.priceChangedSuccess)(result.choiceDeltas, result.asConfigured, result.strikeThroughPriceModel));
    });
  };
}
function normalizeOptionData(groups) {
  var choiceSchema = new _normalizr.schema.Entity('choices', {}, {
    processStrategy: function processStrategy(value, parent, key) {
      if (key === 'groupedChoices') {
        return _objectSpread(_objectSpread({}, value), {}, {
          groupId: parent.id,
          sequence: value.sequenceNumber
        });
      }
      return _objectSpread(_objectSpread({}, value), {}, {
        optionId: parent.id,
        parentOptionType: parent.optionType
      });
    }
  });
  var choiceGroupSchema = new _normalizr.schema.Entity('choiceGroups', {
    groupedChoices: [choiceSchema]
  }, {
    idAttribute: 'groupId',
    processStrategy: function processStrategy(value, parent) {
      return _objectSpread(_objectSpread({}, value), {}, {
        optionId: parent.id
      });
    }
  });
  var optionSchema = new _normalizr.schema.Entity('options', {
    choices: [choiceSchema],
    choiceGroups: [choiceGroupSchema]
  }, {
    processStrategy: function processStrategy(value, parent, key) {
      if (key === 'dependentOptions') {
        return _objectSpread(_objectSpread({}, value), {}, {
          parentChoiceId: parent.id
        });
      }
      return _objectSpread(_objectSpread({}, value), {}, {
        parentGroupId: parent.id
      });
    }
  });
  choiceSchema.define({
    dependentOptions: [optionSchema]
  });
  var groupsSchema = new _normalizr.schema.Entity('groups', {
    options: [optionSchema]
  }, {
    idAttribute: 'sequenceNumber'
  });
  return (0, _normalizr.normalize)(groups, [groupsSchema]).entities;
}

/** Converts `preconfiguration` predicates to `{ choiceId, choiceValue }`
    objects and applies saved choices for this product, if any. */
var getPreconfiguration = function getPreconfiguration(preconfiguration, savedProductChoices, _ref) {
  var options = _ref.options,
    choices = _ref.choices;
  var mapChoice = function mapChoice(val, optionId) {
    if (!val.predicate) {
      return val;
    }
    var choice = (0, _find["default"])(choices, function (c) {
      return c.optionId === optionId && val.predicate(c);
    });
    return choice && _objectSpread(_objectSpread({}, val), {}, {
      choiceId: choice.id
    });
  };
  var preconfig = {};

  // step 0: generate preconfiguration from function if provided
  var preconfiguredChoices = typeof preconfiguration === 'function' ? preconfiguration(options, choices) : preconfiguration;

  // step 1: copy preconfiguration & map predicates/internalNames
  (0, _toPairs["default"])(preconfiguredChoices).forEach(function (_ref2) {
    var _ref3 = (0, _slicedToArray2["default"])(_ref2, 2),
      key = _ref3[0],
      val = _ref3[1];
    var optionId = Number(key) || (0, _find["default"])(options, {
      internalName: key
    }).id;
    preconfig[optionId] = mapChoice(val, optionId);
  });

  // step 2: add saved choices, if any
  var _getSettings = (0, _settings.getSettings)(),
    configurationId = _getSettings.configurationId,
    persistenceKey = _getSettings.persistenceKey,
    productId = _getSettings.productId;
  // we shouldn't use the persisted options if we're editing
  if (!configurationId && persistenceKey) {
    var savedChoicesByProduct = (0, _get["default"])(savedProductChoices, "".concat(persistenceKey, ".").concat(productId), {});
    preconfig = _objectSpread(_objectSpread({}, savedChoicesByProduct), preconfig);
  }
  return (0, _omitBy["default"])(preconfig, _isUndefined["default"]);
};
function loadOptions() {
  return function (dispatch, getState) {
    var _getSettings2 = (0, _settings.getSettings)(),
      preconfiguration = _getSettings2.preconfiguration,
      onLoadSuccess = _getSettings2.onLoadSuccess,
      onLoadFailure = _getSettings2.onLoadFailure;
    dispatch((0, _ajaxStatusActions.configuratorLoad)());
    dispatch((0, _ajaxStatusActions.beginAjaxLoad)('Loading Options'));
    dispatch((0, _ajaxStatusActions.beginAjaxCall)());
    return (0, _optionsApi["default"])().then(function (_ref4) {
      var data = _ref4.data;
      var normalized = normalizeOptionData(data.groups);
      var savedProductChoices = getState().configurator.savedProductChoices;
      var preselectedChoices = getPreconfiguration(preconfiguration, savedProductChoices, normalized);

      // any product data other than groups/options/choices
      // (brand, productType, siteProductName, mainImageUrl, productId, isVisualized)
      var productInfo = (0, _omit["default"])(data, 'groups');

      // getUnavailableChoices needs this to complete first
      var round1 = function round1() {
        return Promise.all([dispatch(loadOptionsSuccess(normalized, preselectedChoices, productInfo))]);
      };

      // run everything else in "parallel"
      var round2 = function round2() {
        return Promise.all([dispatch((0, _rulesActions.executeImmediateRules)()), dispatch((0, _dictionaryActions.loadDictionaryTerms)())]);
      };
      var round3 = function round3() {
        return Promise.all([dispatch((0, _getVisualizerImageUrl["default"])()), dispatch((0, _choiceActions.getUnavailableChoices)()), dispatch((0, _choiceActions.updateSelectedChoices)())]);
      };
      var round4 = function round4() {
        return Promise.all([dispatch((0, _choiceActions.updatePricing)())]);
      };
      return round1().then(round2).then(round3).then(round4);
    })["catch"](function (error) {
      if (error instanceof _GetOptionsError["default"]) {
        dispatch({
          type: _actionTypes.GET_OPTIONS_ERROR,
          err: error.originalError
        });
      } else {
        console.log(error); // eslint-disable-line no-console
      }
      onLoadFailure && onLoadFailure();
      dispatch((0, _ajaxStatusActions.configuratorLoadFailure)());
    }).then(function (results) {
      dispatch((0, _ajaxStatusActions.endAjaxLoad)());
      dispatch((0, _ajaxStatusActions.configuratorLoadSuccess)());
      onLoadSuccess && onLoadSuccess();
      return results;
    });
  };
}

// This is partnerProductId
function loadOptionsForProductId(productId, configId) {
  var clearStateSmoothly = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var skipRules = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var isLongLoad = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  return function (dispatch, getState) {
    var _getSettings3 = (0, _settings.getSettings)(),
      preSelectOptionsApi = _getSettings3.preSelectOptionsApi,
      configurationId = _getSettings3.configurationId,
      preconfiguration = _getSettings3.preconfiguration,
      onLoadSuccess = _getSettings3.onLoadSuccess,
      onLoadFailure = _getSettings3.onLoadFailure,
      externalProductId = _getSettings3.externalProductId,
      equivalenceKeyFilter = _getSettings3.equivalenceKeyFilter,
      persistValueKeyFilter = _getSettings3.persistValueKeyFilter;

    // Get Selected Choices tags
    var _getState$configurato2 = getState().configurator,
      choices = _getState$configurato2.choices,
      options = _getState$configurato2.options;
    var selectedChoices = (0, _filter["default"])(choices, function (a) {
      return a.isSelected && a.isActive && a.tags.length > 0;
    });

    // TODO add filter here when Eric Schall's team has come up with a strategy
    var selectedChoiceTagsForValuePersist = (0, _map["default"])(selectedChoices, function (choice) {
      var value = choice.value,
        tags = choice.tags;
      var choiceKey = (0, _find["default"])(tags, function (tag) {
        return (0, _startsWith["default"])(tag, persistValueKeyFilter);
      });
      var optionKey;
      if (choiceKey) {
        var option = options[choice.optionId];
        // eslint-disable-next-line prefer-destructuring
        optionKey = option.tags.filter(function (tag) {
          return (0, _startsWith["default"])(tag, persistValueKeyFilter);
        })[0];
      }
      return choiceKey && optionKey && {
        choiceKey: choiceKey,
        value: value,
        optionKey: optionKey
      };
    });
    var selectedChoiceTagsForEquivalenceMatch = (0, _map["default"])(selectedChoices, function (choice) {
      // eslint-disable-next-line prefer-destructuring
      var choiceKey = choice.tags.filter(function (tag) {
        return (0, _startsWith["default"])(tag, equivalenceKeyFilter);
      })[0];
      var optionKey;
      if (choiceKey) {
        var option = options[choice.optionId];
        // eslint-disable-next-line prefer-destructuring
        optionKey = option.tags.filter(function (tag) {
          return (0, _startsWith["default"])(tag, equivalenceKeyFilter);
        })[0];
      }
      return optionKey && choiceKey && {
        optionKey: optionKey,
        choiceKey: choiceKey
      };
    });
    dispatch((0, _ajaxStatusActions.configuratorLoad)());
    dispatch((0, _ajaxStatusActions.beginAjaxLoad)('Loading Options', isLongLoad));
    dispatch((0, _ajaxStatusActions.beginAjaxCall)());
    return (0, _optionsApiWithPreSelection["default"])(preSelectOptionsApi, productId, configId || configurationId,
    // Added this to get config details by id
    externalProductId, productId, (0, _compact["default"])((0, _flatten["default"])(selectedChoiceTagsForEquivalenceMatch)), (0, _compact["default"])(selectedChoiceTagsForValuePersist)).then(function (response) {
      if (!clearStateSmoothly) {
        dispatch(clearState());
      }
      return response;
    }).then(function (_ref5) {
      var data = _ref5.data;
      var normalized = normalizeOptionData(data.groups);
      var savedProductChoices = getState().configurator.savedProductChoices;
      var preselectedChoices = getPreconfiguration(preconfiguration, savedProductChoices, normalized);

      // any product data other than groups/options/choices
      // (brand, productType, siteProductName, mainImageUrl, productId, isVisualized)
      var productInfo = (0, _omit["default"])(data, 'groups');

      // getUnavailableChoices needs this to complete first
      // TODO see if we can shorten this chain
      var round1 = function round1() {
        return Promise.all([dispatch(loadOptionsSuccess(normalized, preselectedChoices, productInfo, clearStateSmoothly))]);
      };
      var round2 = function round2() {
        return Promise.all([!skipRules && dispatch((0, _rulesActions.executeImmediateRules)()), dispatch((0, _dictionaryActions.loadDictionaryTerms)())]);
      };
      var round3 = function round3() {
        return Promise.all([dispatch((0, _getVisualizerImageUrl["default"])()), dispatch((0, _choiceActions.getUnavailableChoices)()), dispatch((0, _choiceActions.updateSelectedChoices)())]);
      };
      var round4 = function round4() {
        return Promise.all([dispatch((0, _choiceActions.updatePricing)())]);
      };
      return round1().then(round2).then(round3).then(round4);
    })["catch"](function (err) {
      console.log(err); // eslint-disable-line no-console
      onLoadFailure && onLoadFailure();
      dispatch((0, _ajaxStatusActions.configuratorLoadFailure)());
    }).then(function (results) {
      dispatch((0, _ajaxStatusActions.endAjaxLoad)());
      dispatch((0, _ajaxStatusActions.configuratorLoadSuccess)());
      onLoadSuccess && onLoadSuccess();
      return results;
    });
  };
}
//# sourceMappingURL=optionActions.js.map